import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./Notification.css";
import Overlay from "../../components/Overlay";
import { extractDate, subadminAccessChange } from "../../utils/functions";
import { BsPlus, } from "react-icons/bs";
import Input from "../../components/Input";
import ReactReadMoreReadLess from "react-read-more-read-less";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from '@mui/material/PaginationItem';
import SearchBar from "material-ui-search-bar";
import { TextField, Popover, Box } from "@mui/material";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Select
} from "@material-ui/core";

// icons 
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  ProfileDetailForm,
  Button,
} from "./NotificationManagementElements";
import NoResults from "../../components/NoResult";


const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 6px', // adds vertical spacing between rows
  },
  tableMainContainer: {
    maxHeight: "65vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    // border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    // border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));


const NotificationManagement = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "Notification Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;

  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [title, setTitle] = useState("");
  const [userType, setUserType] = useState("");
  const [filterKey, setFilterKey] = useState(0);


  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update page and trigger data fetch
  };


  // For Search functionality
  const [searchTerm, setSearchTerm] = useState("");

  function myDeb(call, d = 1000) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        call(...args);
      }, d);
    };
  }

  const SearchAccountManagement = myDeb((search) => {
    // setSelectedRows([]);
    setSearchTerm(search);
    setPage(1); // Reset to the first page on search
  });

  const cancelSearch = () => {
    setSearchTerm("");
    setPage(1); // Reset to the first page when search is canceled
  };


  // Filter date
  //  const [anchorEl, setAnchorEl] = useState(null);
  //  const [title, setTitle] = useState("");
  // const [userType, setUserType] = useState("");




  const advanceFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const handleApply = () => {
    if (!userType && !title) {
      toast.warning("Please select Title or User Type.", {
        position: "top-right",
      });
      return;
    }

    setAnchorEl(null); // Close the popover
    setPage(1); // Reset to first page
    getNotifications(1); //Trigger API manually with filters
  };

  const handleCancel = () => {
    setTitle("");
    setUserType("");
    setPage(1);
    setAnchorEl(null);
    getNotifications(1);
    setFilterKey(prev => prev + 1);
  };


  const handleClosefilter = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const open = Boolean(anchorEl);
  const ids = open ? "filter-popover" : undefined;







  // Get user data
  useEffect(() => {
    getNotifications(page);

  }, [page, rowsPerPage, searchTerm, filterKey]);

  const getNotifications = async (currentPage) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.post(`/private/getNotifications?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
        title: title ? title : "",
        userType: userType ? String(userType) : "",
      });

      setTableData(data?.data?.docs);
      setTotalDocs(data?.data?.totalDocs);
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <DashboardHeading>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="common-heading">Notification Management</div>
                <Button
                  style={{ backgroundColor: "#5088FB", color: "#ffffff", fontSize: "14px", fontFamily: "Roboto", padding: "6px 10px" }}
                  onClick={() => {
                    navigate("/createNotification");
                  }}
                  disabled={!canAdd && adminData?.userType == "subAdmin"}
                >
                  <BsPlus
                    style={{
                      color: "#ffffff",
                      // marginRight: "4px",
                      fontSize: "1.3rem",

                    }}
                  />
                  Create New
                </Button>
              </div>
            </DashboardHeading>



            <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
              <SearchBar
                style={{
                  minWidth: "25rem",
                  height: "40px",
                  borderRadius: "20px",
                  backgroundColor: "#F8F9FB",
                  color: "#212121",
                  fontStyle: "Italic",
                  fontWeight: 300,
                  fontSize: "15px",
                  fontFamily: "Roboto",
                }}
                className={"heightfix"}
                onChange={(e) => {
                  SearchAccountManagement(e);
                }}
                onCancelSearch={cancelSearch}
                placeholder="Search by Title"
                inputProps={{ maxLength: 30 }}
              />
              <div
                type="button"
                style={{ color: "#5088FB", fontSize: "16px", fontFamily: "Roboto", fontWeight: "500" }}
                onClick={advanceFilterClick}
              >
                <BsPlus
                  style={{
                    color: "#5088FB",
                    marginRight: "6px",
                    fontSize: "1.5rem",
                  }}
                />
                Advance Filter
              </div>
            </div>


            <TableContainer
              className={classes.tableMainContainer}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.tableHeadingRow}>
                    <TableCell className={classes.tableHeadingCell}>
                      S.No
                    </TableCell>
                    <TableCell className={classes.tableHeadingCell}>
                      <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                        Title
                      </div>
                    </TableCell>
                    <TableCell className={classes.tableHeadingCell}>
                      <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                        Description
                      </div>
                    </TableCell>
                    <TableCell className={classes.tableHeadingCell}>
                      User Type
                    </TableCell>
                  </TableRow>
                </TableHead>
                {tableData && tableData.length > 0 ? (
                  <>
                    <TableBody>
                      {tableData.map((user, index, block) => (
                        <TableRow className={classes.tableBodyRow} key={user._id}>

                          <TableCell className={classes.textMiddle}>
                            <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div style={{ textAlign: "left", marginLeft: "3rem" }}>
                              {(get(user, "title", "---"))}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle} >
                            <div style={{
                              width: "20rem",
                              overflowWrap: "anywhere",
                              textAlign: "left",
                              marginLeft: "3rem"
                            }}>
                              <ReactReadMoreReadLess
                                charLimit={10}
                                readMoreText={"Read more"}
                                readLessText={"Read less"}
                                readMoreStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                                readLessStyle={{ color: "blue", cursor: "pointer", fontSize: "12px" }}
                              >
                                {get(user, "description", "---")}
                              </ReactReadMoreReadLess>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle} style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}>
                            <div style={{
                              height: "28px",
                              background: "#6160601F",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "78px"
                            }} >
                              <span style={{
                                textTransform: "capitalize",
                                color: "#484848",
                                fontSize: "14px",
                                fontWeight: "500",
                                fontFamily: "Roboto",
                              }}>
                                {get(user, "type") == "2"
                                  ? "manually"
                                  : get(user, "type") == "1"
                                    ? "all"
                                    : "--"}
                              </span>
                            </div>

                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                          <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
            {(tableData && tableData.length > 0) && (
              <>
                <Stack spacing={2} className={classes.paginationContainer}>
                  <Pagination
                    count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                    page={page}
                    onChange={(event, value) => handleChangePage(event, value)} // Update page
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                        {...item}
                      />
                    )}
                  />
                </Stack>
              </>
            )}
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>


      {/* Filter Popover */}
      <Popover
        id={ids}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosefilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, width: "300px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.8rem" }}>
            <div className="text-filter">Advance Filter</div>
            <div className="clear-filter" onClick={handleCancel}>Reset all</div>
          </div>

          <div className="mb-3">
            <label className="headname">Title</label>
            <Input
              type="text"
              className="form-control"
              style={{
                background: "#FFFFFF",
                border: "1px solid #D0D5DD",
                padding: "5px",
                borderRadius: "4px"
              }}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter Title"
            />
          </div>

          <div className="mb-3">
            <label className="headname">User Type</label>
            <select
              className="form-control"
              style={{
                backgroundColor: "#FFFFFF",
                border: "1px solid #D0D5DD",
                padding: "8px",
                borderRadius: "4px",
                appearance: "auto", // Ensure dropdown arrow is visible
                WebkitAppearance: "menulist", // for Safari
                MozAppearance: "menulist", // for Firefox
                paddingRight: "30px",
              }}
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
            >
              <option value="">Select User Type</option>
              <option value="1">All</option>
              <option value="2">Manually</option>
            </select>
          </div>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
            <Button onClick={handleClosefilter} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleApply} style={{ background: "#5088FB", color: "#ffffff", fontFamily: "Roboto", fontWeight: "700" }}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>




      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationManagement);








